/*
 * @Author: zhujian 
 * @Date: 2018-02-26 17:51:03 
 * @Last Modified by: zhujiapeng
 * @Last Modified time: 2021-01-15 11:30:40
 */

import React from 'react';
import PageControl from '../components/PageControl';
import ConfirmPlayCard from './ConfirmPlayCard';
import BindCardModal from './BindCardModal';
import _ from 'underscore';
import Permission from '../../core/permission';
import './AddNewCardRecordModal.less';
import AxiosTS from '../../core/axios';
import CONFIG from '../../core/config';
import { intToHours, formatDate } from '../../core/function';
import { withRouter } from 'react-router-dom';
import {
  message,
  Modal,
  Table,
  Tooltip
} from 'antd';

class AddNewCardRecordModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {},
      query: {
        size: 10,
        current: 1,
        instId: window.currentUserInstInfo.instId,
        toBeCheckType: this.props.type,
      },
      columns: []
    }
  }
  componentDidMount() {
    this.getColumns();
    this.fetchStudentList();
  }

  fetchStudentList = (current = 0) => {
    this.setState({
      loading: true
    });
    const { query } = this.state;
    query.current = current;
    AxiosTS.Business('public/attendance/getToBeCheckList', { ...query, current: query.current + 1 }).then((res) => {
      const data = res.result.records || [];
      const group = _.groupBy(data, function (item) { return item.studentId; });
      let list = [];
      _.map(_.pairs(group), (item, key) => {
        _.map(item[1], (_item, index) => {
          if (index == 0) {
            _item.isFirst = true;
            _item.len = item[1].length;
            _item.time = item[0]
          }
          if (index < item[1].length - 1) {
            _item.hasBorder = true;
          }
          list.push(_item)
        })
      })
      let isOdd = true;
      _.map(list, (item) => {
        if (item.isFirst) {
          isOdd = !isOdd;
        }
        item.isOdd = isOdd;
      })
      this.setState({
        dataSet: list,
        totalPage: res.result.total,
        loading: false
      });
    }, (res) => {
      message.error(res.resultMsg);
      this.setState({
        loading: false
      });
    });
  }

  bindCard = (studentId) => {
    const modal = <BindCardModal
      studentId={studentId}
      success={() => {
        this.setState({
          modal: null
        });
        const { query } = this.state;
        this.fetchStudentList(query.current);
      }}
      close={() => {
        this.setState({
          modal: null
        });
      }}
    />
    this.setState({
      modal
    });
  }

  addCardRecord = (record) => {
    const modal = <ConfirmPlayCard
      item={record}
      type={this.props.type}
      close={() => {
        this.setState({
          modal: null
        });
        this.fetchStudentList();
        this.props.getUncheckStudent();
      }}
    />
    this.setState({
      modal
    });
  }

  getColumns() {
    const columns = [
      {
        title: '学员姓名',
        width: "10%",
        dataIndex: 'name',
        key: 'name',
        render: (text, record, index) => {
          const obj = {
            children: record.studentName,
            props: {},
          };
          if (record.isFirst) {
            obj.props.rowSpan = record.len;
          } else {
            obj.props.rowSpan = 0;
          }
          return obj
        }
      },
      {
        title: '手机号',
        width: "10%",
        dataIndex: 'phone',
        key: 'phone',
        render: (text, record) => {
          let { phone } = record;
          if (Permission.hasEduStudentPhone() === false) {
            phone = phone.substr(0, 3) + '****' + phone.substr(7);
          }
          const obj = {
            children: phone,
            props: {},
          };
          if (record.isFirst) {
            obj.props.rowSpan = record.len;
          } else {
            obj.props.rowSpan = 0;
          }
          return obj
        }
      },

      {
        title: '人脸',
        width: '5%',
        dataIndex: 'face',
        key: 'face',
        align: 'center',
        render: (text, record, index) => {
          const Api = CONFIG.api.split('-')[0];
          const obj = {
            children: (<div className='cardimg'>
              <span >
                {
                  Permission.userAttendanceFace() ? (record.faceResourceIds) ?
                    <Tooltip
                      placement="right"
                      title='已采集人脸'
                    >
                      <a
                        // href={`https://${getEnvValue()}.xiaomai5.com/faceDetection/${process.env.DEPLOY_ENV === 'gray' ? 'gray/' : ''}index.html#home?studentId=${record.studentId}&name=${record.studentName}&phone=${record.phone}`}
                        // target="_blank"
                        className="icon fr iconfont "
                        style={{ color: '#4AB78D', fontSize: 22 }}
                        onClick={() => {
                          this.props.history.replace(`/home?studentId=${record.studentId}&name=${record.studentName}&phone=${record.phone}`);
                          window.location.reload();
                        }}
                      >
                        &#xe80a;
                      </a>
                    </Tooltip>
                    : <Tooltip
                      placement="right"
                      title='点击采集人脸'
                    >
                      <a
                        // href={`https://${getEnvValue()}.xiaomai5.com/faceDetection/${process.env.DEPLOY_ENV === 'gray' ? 'gray/' : ''}index.html#home?studentId=${record.studentId}&name=${record.studentName}&phone=${record.phone}`}
                        // target="_blank"
                        className="icon iconfont handLike"
                        style={{ color: '#BFBFBF', fontSize: 22 }}
                        onClick={() => {
                          this.props.history.replace(`/home?studentId=${record.studentId}&name=${record.studentName}&phone=${record.phone}`);
                          window.location.reload();
                        }}
                      >&#xe80a;</a>
                    </Tooltip> : <span className="icon iconfont handLike"
                      onClick={() => {
                        Modal.info({
                          title: `您的校区未购买刷卡考勤权限`,
                          content: '请联系运营老师或售后电话400-6677-456咨询购买',
                          icon: <span className="icon iconfont default-confirm-icon">&#xe6f1;</span>,
                          okText: '我知道了',
                        })
                      }}
                      style={{ color: '#BFBFBF', fontSize: 22 }}  >&#xe80a;</span>
                }
              </span>
            </div>),
            props: {},
          };
          if (record.isFirst) {
            obj.props.rowSpan = record.len;
          } else {
            obj.props.rowSpan = 0;
          }
          return obj
        }
      },
      {
        title: this.props.type === 'NOT_CHECK' ? "待签到时间" : '今日签到时间',
        width: "10%",
        dataIndex: 'remindTime',
        key: 'remindTime',
        render: (text, record, index) => {
          const obj = {
            children: this.props.type === 'NOT_CHECK' ? intToHours(record.startMinute) : formatDate('H:i', record.checkInTime),
            props: {},
          };
          if (record.isFirst) {
            obj.props.rowSpan = record.len;
          } else {
            obj.props.rowSpan = 0;
          }
          return obj
        }
      },
      {
        title: '操作',
        width: "10%",
        dataIndex: 'remindTime',
        key: 'operater',
        render: (text, record, index) => {
          // 5.0且没有添加/删除考勤记录权限
          if (window.NewVersion && !Permission.useAddDealAttendance()) {
            return '-';
          } else {
            const obj = {
              children: <a onClick={() => {
                this.addCardRecord(record)
              }}>{this.props.type == 'NOT_CHECK' ? "手动签到" : '手动签退'} </a>,
              props: {},
            };
            if (record.isFirst) {
              obj.props.rowSpan = record.len;
            } else {
              obj.props.rowSpan = 0;
            }
            return obj;
          }
        }
      },
    ];

    if (Permission.userAttendanceCard()) {
      columns.splice(2, 0, {
        title: '考勤卡',
        width: '5%',
        dataIndex: 'cardStatus',
        key: 'cardStatus',
        render: (text, record, index) => {
          const obj = {
            children: (<div className='cardimg'>
              <span id={'card_status_' + index}>
                {(record.cardId && record.cardId != '-1') ?
                  <Tooltip
                    placement="right"
                    title='已绑定卡号'
                  >
                    <span
                      className="icon  fr iconfont "
                      style={{ color: '#4AB78D', fontSize: 22 }}
                    >
                      &#xe687;
                      </span>
                  </Tooltip>
                  : <Tooltip
                    placement="right"
                    title='点击绑卡'
                  >
                    <span
                      className="icon iconfont handLike"
                      onClick={() => { this.bindCard(record.studentId) }}
                      style={{ color: '#BFBFBF', fontSize: 22 }}
                    >&#xe689;</span>
                  </Tooltip>
                }
              </span>
            </div>),
            props: {},
          };
          if (record.isFirst) {
            obj.props.rowSpan = record.len;
          } else {
            obj.props.rowSpan = 0;
          }
          return obj
        }
      })
    }
    if (this.props.type == 'NOT_CHECK') {
      columns.splice(Permission.userAttendanceCard() ? 4 : 3, 0, {
        title: '今日排课',
        width: "20%",
        dataIndex: 'class',
        key: 'class',
        render: (text, record, index) => {
          return <span className={record.hasBorder ? 'child-border' : ""} >{`${intToHours(record.startMinute)}-${intToHours(record.endMinute)}  ${record.className}`}</span>
        }
      })
    }
    this.setState({
      columns
    });
  }

  render() {
    return (
      <Modal
        className="add-attendance"
        width={'100rem'}
        title={this.props.title}
        visible={true}
        footer={null}
        onCancel={this.props.close}
      >
        {
          this.props.type == 'NOT_CHECK' &&
          <p className='mb10' style={{ color: "#999" }}  >凌晨0点后创建的今日排课、审批通过的今日请假不纳入待签到统计范围内</p>
        }
        <Table
          pagination={false}
          columns={this.state.columns}
          loading={this.state.loading}
          size='small'
          rowClassName={(record) => {
            return record.isOdd ? '' : 'child-item';
          }}
          dataSource={this.state.dataSet}
        />
        <div className="box-footer">
          <PageControl
            size="small"
            current={this.state.query.current}
            pageSize={this.state.query.size}
            total={this.state.totalPage}
            toPage={(page) => {
              this.fetchStudentList(page);
            }}
          />
        </div>
        {this.state.modal}
      </Modal>
    );
  }
}

export default withRouter(AddNewCardRecordModal);

